import { render } from "./AssessmentTaskTable.vue?vue&type=template&id=36980315"
import script from "./AssessmentTaskTable.vue?vue&type=script&lang=js"
export * from "./AssessmentTaskTable.vue?vue&type=script&lang=js"

import "./AssessmentTaskTable.vue?vue&type=style&index=0&id=36980315&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__